import React, { Component } from "react";
import styled from "styled-components";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Moment from "moment";
import GenericModal from "../../GenericModal";
import PencilImage from "../../../images/pencil.svg";
import employeeService from "../../../services/Employee.service"

const UnvestedAwardDetails = styled(GenericModal)`
  .generic-modal-content,
  .generic-modal-footer {
    padding: 0;
  }
`;

const Content = styled.div`
  h3 {
    font-family: Lato-Regular;
    font-size: 12px;
    font-weight: normal;

    color: #666666;
    line-height: 16px;
    margin: 0px;
    padding: 0px;
  }

  .value {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2b2b2b;
    line-height: 22px;

    > .pencil {
      cursor: pointer;
    }
  }

  .logo {
    font-family: Lato-Regular;
    font-size: 13px;
    color: #2b2b2b;
    line-height: 22px;
  }

  .disclaimer {
    font-family: Lato-Regular;
    font-size: 12px;
    color: #666666;
    margin-top: 10px;
    display: block;
  }

  .award-name {
    display: block;
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2b2b2b;
    line-height: 22px;
    margin-top: 3px;
  }

  .award-date {
    display: block;
    font-family: Lato-Regular;
    font-size: 12px;
    color: #666666;
    line-height: 16px;
  }

  img {
    height: 15px;
    width: 15px;
    padding-left: 5px;
  }

  > div.award-info-section, > div.vest-details-section, > div.tax-details-section, > div.more-info-section {
    // Desktop version.
    @media (min-width: 768px) {
      padding: 16px 20px 17px 20px;
    }

    // Mobile version.
    @media (max-width: 768px) {
      padding: 15px 15px 10px 15px;
    }
  }

  // Transaction Summary
  > div.award-info-section {
    background-color: #F2F2F2;

    // Award Info
    > div:first-child {
      > h3 {
        margin-bottom: 6px;
      }
    }
  }

  > div.vest-details-section {
    border-bottom: 1px solid #DDDDDD;
  }

  // Section for option only 
  > div.more-info-section {
    border-top: 1px solid #DDDDDD;
    .disclaimer {
      text-align: center;
      height: auto;
      a {
            text-decoration: none;
            color: #1D71BB;
            line-height: 16px;
          }
    }
  }

  > div.vest-details-section, > div.tax-details-section {

    // Details
    .unvested-award-details-details {
      > div > div {
        vertical-align: top;
      }

      // Header
      > div:nth-child(1) {
        margin-bottom: 11px;
        display: flex;
        align-items: center;
        height: auto;
      }

      // Content
      > div:nth-child(2) {
        > div {
          display: inline-block;
          width: calc(100% / 3);

          > h3 {
            margin: 0;
            padding: 0;
          }
          a {
            text-decoration: none;
            color: #1D71BB;
            line-height: 16px;
          }
        }
      }
    }
  }
`;




export class UnvestedAwardDetailsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onPaymentMethodClicked = () => {
    this.props.done();
    this.props.onChangePaymentMethod && this.props.onChangePaymentMethod(this.props.vest);
  }

  getFractionalElection = (vest) => {
    if (this.props.fractional_mode && employeeService.hasFractionalEligibleVest(this.props.employee)){
      return " (" + employeeService.getVestFractionalElectionText(this.props.t, this.props.employee, vest) + ")"
    }
    else{
        return ""
    }
  }

  onKeyDown = (event) => {
      switch (event.keyCode) {
          case 32: // SPACE
          case 13: // RETURN
              this.onPaymentMethodClicked();
              event.stopPropagation();
              event.preventDefault();
              break;

          default:
              break;
      }
  }

  render() {
    if (this.props.visible) {
      const { t, award, vest } = this.props;
      const isRsu = employeeService.isRSU(award)
      const awardedDate = t("UnvestedAwardDetailsDialog.AwardedOn", {
        awarded_date: Moment(award.awarded_date).format("ll")
      });
      const acceptedDate = award.acceptance_date
        ? t("UnvestedAwardDetailsDialog.AcceptedOn", {
            accepted_date: Moment(award.acceptance_date).format("ll")
          })
        : t("UnvestedAwardDetailsDialog.NotAccepted");

      const vest_tax_rate = vest.tax_rate === null ? '' : new Intl.NumberFormat(this.props.locale, {style: 'percent',minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(vest.tax_rate)
      const shares_sold = vest.shares_sold === null ? -1 : vest.shares_sold

      const brokerLabels = [t('VestingSummary.TaxBrokerLabel'), t('VestingSummary.NetBrokerLabel')]

      const brokerUrl = employeeService.getBrokerUrl(this.props.broker, this.props.employee)

      return (
        <UnvestedAwardDetails
          title={
            award &&
            t(vest.vested ? 'UnvestedAwardDetailsDialog.TitleVested' : 'UnvestedAwardDetailsDialog.TitleUpcoming', {
              award_date: Moment(vest.vest_date).format("ll")
            })
          }
          visible={this.props.visible}
          onCloseDialog={this.props.done}
          width={380}
          contentClassName="unvested-award-details-content"
          className="upcoming-vest-summary-dialog"
        >
          <Content>
            {/* Transaction Summary - Unvested */}
            <div className="award-info-section">
              {/* Award Info */}
              <div>
                <h3>{t("UnvestedAwardDetailsDialog.AwardInfo")}</h3>
                <span className="value">{`${award.amazon_award_name} | ${
                  award.amazon_award_id
                } `}</span>
                <span className="award-date">
                  {awardedDate} ({acceptedDate})
                </span>
              </div>
            </div>

            <div className="vest-details-section">

              {/* Vest Details */}
              <div className="unvested-award-details-details">
                <div>
                  <h3>{t("UnvestedAwardDetailsDialog.VestDetails")}</h3>
                </div>

                  <div>
                    {isRsu &&
                      <h3>{t("UnvestedAwardDetailsDialog.RSUsVesting")}</h3>
                    }
                    {!isRsu &&
                      <h3>{t(vest.vested ? 'UnvestedAwardDetailsDialog.OptionsVested' : 'UnvestedAwardDetailsDialog.OptionsVesting')}</h3>
                    }
                    <span className="value">{vest.vest_shares}</span>
                  </div>
                  <div>
                    <h3>{t('UnvestedAwardDetailsDialog.BrokersLabel')}</h3>
                    <span className="logo">
                      {this.props.brokers && this.props.brokers.map((broker, i) =>
                          <div key={i}>{broker}&nbsp;{this.props.brokers.length > 1 && brokerLabels[i]}</div>
                      )}
                    </span>
                  </div>

              </div>
            </div>

            { isRsu &&
              <div className="tax-details-section">
                {/* Tax Details */}
                <div className="unvested-award-details-details">
                  <div>
                    <h3>{t("UnvestedAwardDetailsDialog.TaxDetails")}*</h3>
                  </div>
                  {vest_tax_rate &&

                    <div>
                      <h3>{t("UnvestedAwardDetailsDialog.TotalTaxRate")}</h3>
                      <span className="value">{vest_tax_rate}</span>
                    </div>
                  }
                    <div>
                      <h3>{t("UnvestedAwardDetailsDialog.PaymentMethod")}</h3>
                      <span className="value">
                        {t(`TaxTreatment.${vest.tax_election.code}`) + this.getFractionalElection(vest)}
                        <img tabIndex={0} src={PencilImage} alt={t("UnvestedAwardDetailsDialog.PencilImageAlt")} className="pencil" onKeyDown={this.onKeyDown} onClick={this.onPaymentMethodClicked}/>
                      </span>
                    </div>

                    {shares_sold >= 0 &&
                      <div>
                      <h3>{t("UnvestedAwardDetailsDialog.RSUsSold")}</h3>
                      <span className="value">
                        {shares_sold}
                      </span>
                    </div>
                    }
                  <span className="disclaimer">
                      *{t("UnvestedAwardDetailsDialog.TaxDetailsNote")}
                  </span>

                </div>
              </div>
            }

            {!isRsu &&
              <div className="more-info-section">
                <div className="unvested-award-details-info">
                  <span className="disclaimer">
                      {this.props.broker && (vest.vested ? t('UnvestedAwardDetailsDialog.OptionVestedLink') : t('UnvestedAwardDetailsDialog.OptionUpcomingVestLink'))}
                      {this.props.broker &&
                        <a href={brokerUrl} target='_blank'>{this.props.broker.name}</a>
                      }
                  </span>
                </div>
              </div>
            }

          </Content>
        </UnvestedAwardDetails>
      );
    }

    return null;
  }
}

const mapState = state => ({
  default_tax_rate: state.configuration.default_tax_rate,
  fractional_mode: state.static_content.fractional_mode,
  employee: state.employee
});

export default connect(mapState)(withTranslation("translations")(UnvestedAwardDetailsDialog));
